import { Component, Fragment, h } from 'preact';
import { Text } from 'preact-i18n';
import { NBSP, PaxAmountKey, PaxSelectionOption, Properties } from '../../../../common';
import { AmountField } from '../AmountField/AmountField';
import { FinText } from '../../../../i18n';

type AgeRuleLabel = 'adults' | 'children' | 'c15s' | 'infants';

export interface PaxSelectionProps extends Properties {
  option: PaxSelectionOption;
  onPassengerChange: (type: PaxAmountKey, newAmount: number) => any;
  autofocus?: boolean;
}

export default class PaxSelection extends Component<PaxSelectionProps> {
  setPassengers = (newAmount: number): void => {
    const {
      onPassengerChange,
      option: { type },
    } = this.props;
    onPassengerChange(type, newAmount);
  };

  render({ option: { type, label, amount, canAdd, canRemove }, autofocus }: PaxSelectionProps) {
    const paxType = label as AgeRuleLabel;

    const fieldLabel = (
      <Fragment>
        <span class="capitalize">
          <Text id={`paxAmount.${label}`} plural={amount} />
        </span>
        {NBSP}
        <FinText id={`paxAmountModal.age.${paxType}`} />
      </Fragment>
    );
    return (
      <AmountField
        label={fieldLabel}
        helperText={<FinText id={`paxAmountModal.ageRule.${paxType}`} />}
        amount={amount}
        onIncrease={() => this.setPassengers(amount + 1)}
        onDecrease={() => this.setPassengers(amount - 1)}
        classes={this.props.class}
        disableDecrease={!canRemove}
        disableIncrease={!canAdd}
        decreaseAriaLabel={<FinText id={`paxAmountModal.remove.${paxType}`} />}
        increaseAriaLabel={<FinText id={`paxAmountModal.add.${paxType}`} />}
        testIdSuffix={type}
        autofocus={autofocus}
      />
    );
  }
}
